// extracted by mini-css-extract-plugin
export default {"root":"Ball_root__JZKy+","large":"Ball_large__ug2Vj"};